import {useEffect, useId, useState} from "react";
import {CheckIcon, SearchIcon, ThinCloseIcon} from "../../../components/icons/material-icons";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {CurrencyFormat} from "../../../components/techaran/money";

interface studentInterface {
    id: number,
    name: string,
    class: string, // school class
    isSelected: boolean,
}

export const AdminsChooseStudentsForSciClassModal = (props: {
    active: boolean,
    closeHandler: any,
    classId: string,
    suggestedPrice: number,
    onDone:any,
}) => {
    const [loaded, setLoaded] = useState(false);
    const [list, setList] = useState([] as studentInterface[]);
    const fetchList = () => {
        setLoaded(false);
        PostJSON(
            Apis.server + '/core/admins/center/class/get-students-for-add',
            {
                class: props.classId,
            },
            true,
            (d: {
                result: string,
                reason: string | undefined,
                list: {
                    id: number,
                    name: string,
                    class: string,
                }[] | null,
            }) => {
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setLoaded(true);
                let lst: studentInterface[] = [];
                if (d.list !== null)
                    d.list.forEach(e => {
                        lst.push({
                            id: e.id,
                            name: e.name,
                            class: e.class,
                            isSelected: false,
                        });
                    });
                setList(lst);
            },
            () => {

            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        const isActive = props.active;
        const oldPrice = props.suggestedPrice;
        if (isActive) {
            document.body.classList.add('body-no-scroll');
            fetchList();
            setPrice(oldPrice.toString());
            setLevel('select');
        } else {
            document.body.classList.remove('body-no-scroll');
        }
    }, [props.active]);
    const [search, setSearch] = useState('');
    const [level, setLevel] = useState('select' as 'select' | 'price');
    useEffect(() => {
        if (!loaded || level !== 'select')
            return;
        const filter = search.toUpperCase();
        const lst = document.querySelector('.reports--select-employee-buttons198');
        const btns = (lst as HTMLDivElement).getElementsByTagName('button');
        for (let i = 0; i < btns.length; i++) {
            const b = btns[i].getElementsByTagName('span')[0];
            const v = b.innerHTML.toUpperCase();
            if (v.indexOf(filter) > -1)
                btns[i].style.display = "";
            else
                btns[i].style.display = "none";
        }
    }, [search]);
    const [price, setPrice] = useState('');
    const priceId = useId();
    const saveChanges = () => {
        const data = {
            price:price.trim(),
            students:[...list],
        };
        const classID = props.classId;
        let lst:number[] = [];
        data.students.forEach(e=>{
           if(e.isSelected)
               lst.push(e.id);
        });
        if(price === ''){
            ShowSnackbar(
                'لطفا یک مبلغ وارد کنید.',
                'باشه',
                5000,
            );
            return;
        }
        ShowProgressLoading();
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/center/class/add-manual',
            {
                class:classID.toString(),
                students:JSON.stringify(lst),
                price:data.price.toString(),
            },
            true,
            (d: {
                result: string,
                reason: string,
                count:number,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                ShowSnackbar(
                    `تعداد ${CurrencyFormat(d.count)} دانش‌آموز اضافه گردید.`,
                    'باشه',
                    5000,
                );
                props.onDone();
                props.closeHandler();
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    const isAllChecked = () => {
        const lst = [...list];
        let isAllChecked = true;
        lst.forEach(e => {
            if (!e.isSelected)
                isAllChecked = false;
        });
        return isAllChecked;
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '')} style={loaded ? {top: 20} : {}}>
                <div className="web-modal-header">
                    <div><b>افزودن دستی دانش‌آموزان</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="reports--select-employee">
                        {
                            loaded ?
                                (
                                    level === 'price' ?
                                        <>
                                            <div className="add-student">
                                                <label htmlFor={priceId}>هزینه کلاس:</label>
                                                <input
                                                    type="number"
                                                    min={0}
                                                    className={"form-control"}
                                                    value={price}
                                                    onChange={e => {
                                                        const t = e.currentTarget.value;
                                                        setPrice(t);
                                                    }}
                                                />
                                                <div style={{height: 20}}/>
                                                <div className="d-flex justify-content-end align-items-center"
                                                     style={{gap: 20, marginTop: 30}}>
                                                    <button className="cancel-button" onClick={props.closeHandler}>
                                                        <b>انصراف</b>
                                                    </button>
                                                    <button className="btn-pay" onClick={saveChanges}>
                                                        <b>ذخیره تغییرات</b>
                                                    </button>
                                                </div>
                                            </div>
                                        </> :
                                        <>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <label>انتخاب دانش‌آموزان</label>
                                                <button className="btn-pay" onClick={() => {
                                                    const lst = [...list];
                                                    if (lst.findIndex((e) => e.isSelected) < 0) {
                                                        ShowSnackbar('لطفا حداقل یک دانش‌آموز را انتخاب کنید.', 'باشه', 5000);
                                                        return;
                                                    }
                                                    setLevel('price');
                                                }}>
                                                    <b>مرحله بعدی</b>
                                                </button>
                                            </div>
                                            <div className="pick-device-search">
                                                <button><SearchIcon/></button>
                                                <input type="text"
                                                       value={search}
                                                       onChange={e => setSearch(e.currentTarget.value)}
                                                       onBlur={() => (document.querySelector('.pick-device-search') as HTMLDivElement).classList.remove('active')}
                                                       onFocus={() => (document.querySelector('.pick-device-search') as HTMLDivElement).classList.add('active')}
                                                       className="f-roboto"
                                                       placeholder={"جستجو براساس نام یا کلاس..."}
                                                />
                                            </div>
                                            {
                                                search.trim() === '' && list.length > 0 ?
                                                    <>
                                                        <hr/>
                                                        <button
                                                            className={"techaran-checkbox" + (isAllChecked() ? ' active' : '')}
                                                            onClick={() => {
                                                                const isChecked = isAllChecked();
                                                                if (isChecked)
                                                                    setList(v => {
                                                                        let x = [...v];
                                                                        x.forEach(r => {
                                                                            r.isSelected = false;
                                                                        });
                                                                        return x;
                                                                    });
                                                                else
                                                                    setList(v => {
                                                                        let x = [...v];
                                                                        x.forEach(r => {
                                                                            r.isSelected = true;
                                                                        });
                                                                        return x;
                                                                    });
                                                            }}>
                                                            <i><CheckIcon/></i>
                                                            <span>انتخاب همه</span>
                                                        </button>
                                                        <hr/>
                                                    </> : null
                                            }
                                            <div className="reports--select-employee-buttons198">
                                                {
                                                    list.map((e, i) =>
                                                            <button key={"KJds83jns2228932d" + i}
                                                                    className={"techaran-checkbox" + (e.isSelected ? ' active' : '')}
                                                                    onClick={() => setList(v => {
                                                                        let x = [...v];
                                                                        const id = x.findIndex(r => r.id === e.id);
                                                                        x[id].isSelected = !x[id].isSelected;
                                                                        return x;
                                                                    })}>
                                                                <i>
                                                                    <CheckIcon/>
                                                                </i>
                                                                <span>
                                            {e.name}
                                                                    <em>{(e.class === '' ? 'بدون کلاس' : `${e.class}`)}</em>
                                        </span>
                                                            </button>
                                                    )
                                                }
                                            </div>
                                        </>
                                ) :
                                <div className="d-flex justify-content-center align-items-center"
                                     style={{padding: '70px 0'}}>
                                    <div className="spinner-border" style={{color: '#2b2b2b'}}/>
                                </div>
                        }
                    </div>
                </div>
            </div>
        </>
    );
};